export default __webpack_public_path__ + "static/media/vNight2.fc53eb5d.jpg";